import { api } from 'config'

export const BANNER_URL = {
   getBanners: `${api.public}v1/banner`,
   createBanner: `${api.public}v1/banner`,
   editBanner: `${api.public}v1/banner`,
   removeBanner: `${api.public}v1/banner`
}
